import React from 'react'
import Card from '../../shared/layout/card/Card';
import classes from './imagesplash.module.scss';
function ImageSplash() {
  return (
    <Card className={classes['cargo-image']}></Card>
  )
}

export default ImageSplash